import { SVGProps } from 'react';
import { useDirectionalIcon, IconComponent } from '@/hooks/useDirectionalIcon';

interface DirectionalIconProps extends SVGProps<SVGSVGElement> {
  ltr: IconComponent;
  rtl: IconComponent;
}

/** JSX convenience wrapper around useDirectionalIcon for inline use. */
export function DirectionalIcon({ ltr, rtl, ...svgProps }: DirectionalIconProps) {
  const Icon = useDirectionalIcon(ltr, rtl);
  return <Icon {...svgProps} />;
}
